require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 134
// module chunks = 1